<mat-tab-group class="menu">
    <mat-tab label="Request"><ng-template matTabContent><app-categories></app-categories></ng-template></mat-tab>
    <mat-tab label="Items"><ng-template matTabContent><app-features></app-features></ng-template></mat-tab>
</mat-tab-group>